import React from 'react'
import styled from 'styled-components/macro'
import SocialButton from 'wsc/components/button/SocialButton'
import { MEDIA } from '../../utils/styles'

const ScSocialIconGroup = styled.div`
  margin-top: 20px;
  ${MEDIA.MOBILE`
    margin-top: 24px;
  `}
`

const SocialIconWithMargin = styled(SocialButton)`
  &:not(:first-child) {
    margin-left: 12px;
  }
`

/*----------------------------------------------------------------------------------
 *  RENDER PHASE
 *---------------------------------------------------------------------------------*/

const SOCIAL_LIST = [
  {
    type: 'Facebook',
    url: 'https://www.facebook.com/momdotcomofficial',
  },
  {
    type: 'Twitter',
    url: 'https://twitter.com/Momdotcom',
  },
  {
    type: 'Pinterest',
    url: 'https://www.pinterest.com/momdotcomofficial/',
  },
  {
    type: 'Instagram',
    url: 'https://www.instagram.com/momdotcom/',
  },
  {
    type: 'Youtube',
    url: 'https://www.youtube.com/channel/UC030WRHQCV3ZG5GZdjUCRbw',
  },
]

const FooterSocial = () => {
  const socialLink = SOCIAL_LIST.reduce((result, social) => {
    result.push(
      <SocialIconWithMargin
        key={`social-${social.type}`}
        type={social.type}
        redirectUrl={social.url}
        height={'14px'}
      />
    )

    return result
  }, [])

  return <ScSocialIconGroup>{socialLink}</ScSocialIconGroup>
}

FooterSocial.SocialList = {}

FooterSocial.SocialList = {}

export default FooterSocial
